<div class="mfa-callback" role="status">
  @switch (status) {
    @case ('validating') {
      <p>We are completing your sign-in.</p>
    }
    @case ('expired') {
      <p>Your sign-in session has expired. Please sign in again.</p>
    }
    @default {
      <p>We could not complete your sign-in.</p>
    }
  }

  @if (status !== 'validating') {
    <p>
      <a [routerLink]="loginUrl" [queryParams]="loginQueryParams" replaceUrl>Return to sign-in</a>
    </p>
  }
</div>

